import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation UpdateClientType($companyId: ID!, $id: ID!, $attributes: ClientTypeAttributes!) {
    updateClientType(companyId: $companyId, id: $id, attributes: $attributes) {
      clientType {
        id
        ...UpdatedClientType
      }
      errors {
        path
        message
      }
    }
  }

  fragment UpdatedClientType on ClientType {
    id
    name
    color
  }
`
